(function () {
  // Simple clamp helper
  function clamp(n, min, max) {
    n = Number(n);
    if (Number.isNaN(n)) n = 0;
    return Math.max(min, Math.min(max, n));
  }

  // Count current *product* items in the grid (ignore promo tile)
  function countItems(gridEl) {
    if (!gridEl) return 0;

    var items = gridEl.querySelectorAll("li.grid__item");
    var count = 0;

    items.forEach(function (item) {
      // promo card has a class like "promo-card-<sectionid>"
      var className = item.className || "";
      if (className.indexOf("promo-card-") === -1) {
        count += 1;
      }
    });

    return count;
  }

  // Parse HTML string into a Document we can query
  function parseHTML(htmlString) {
    return new DOMParser().parseFromString(htmlString, "text/html");
  }

  // Single delegated click handler – survives AJAX / filters / section reloads
  document.addEventListener("click", function (event) {
    // Any button whose class starts with gf-load-more-btn-
    var btn = event.target.closest('[class^="gf-load-more-btn-"]');
    if (!btn) return;

    // Guard against double-clicks
    if (btn.dataset.loading === "true") return;
    btn.dataset.loading = "true";

    // Find the wrapper that goes with this button
    var wrap = btn.closest('[class^="gf-load-more-wrap-"]');
    if (!wrap) {
      btn.dataset.loading = "false";
      return;
    }

    // Prefer the nearest ProductGridContainer in case there are multiple grids
    var container =
      wrap.closest("#ProductGridContainer") ||
      document.querySelector("#ProductGridContainer");

    if (!container) {
      btn.dataset.loading = "false";
      return;
    }

    var grid = container.querySelector("#product-grid");
    if (!grid) {
      btn.dataset.loading = "false";
      return;
    }

    // Status elements
    var viewedEl = wrap.querySelector('[class^="gf-load-more-viewed-"]');
    var totalEl = wrap.querySelector('[class^="gf-load-more-total-"]');

    // Read total from data attribute, fall back to current items if missing
    var total = parseInt(wrap.getAttribute("data-total") || "0", 10);
    if (!Number.isFinite(total) || total <= 0) {
      total = countItems(grid);
    }

    function setStatus() {
      var viewed = clamp(countItems(grid), 0, total);

      if (totalEl) totalEl.textContent = String(total);
      if (viewedEl) viewedEl.textContent = String(viewed);

      wrap.setAttribute("data-total", String(total));
      wrap.setAttribute("data-viewed", String(viewed));

      return viewed;
    }

    function getNextUrl() {
      return wrap.getAttribute("data-next-url") || "";
    }

    function setNextUrl(url) {
      if (url) {
        wrap.setAttribute("data-next-url", url);
      } else {
        wrap.removeAttribute("data-next-url");
      }
    }

    // Initialise status on click (now matches Liquid: promo excluded)
    setStatus();

    var nextUrl = getNextUrl();
    if (!nextUrl) {
      btn.dataset.loading = "false";
      return;
    }

    // Basic loading state
    btn.disabled = true;
    btn.classList.add("loading");
    btn.setAttribute("aria-busy", "true");

    fetch(nextUrl, { credentials: "same-origin" })
      .then(function (res) {
        if (!res.ok) throw new Error("Load failed");
        return res.text();
      })
      .then(function (html) {
        var doc = parseHTML(html);

        // Look for the next grid in the fetched HTML
        var newContainer =
          doc.querySelector("#ProductGridContainer") || doc;
        var newGrid =
          newContainer.querySelector("#product-grid") ||
          doc.querySelector("#product-grid");

        if (!newGrid) throw new Error("No grid found in next page");

        // Append only product items
        Array.prototype.slice
          .call(newGrid.querySelectorAll("li.grid__item"))
          .forEach(function (item) {
            grid.appendChild(item);
          });

        // Get updated wrapper from the fetched HTML
        var newWrap =
          newContainer.querySelector('[class^="gf-load-more-wrap-"]') ||
          doc.querySelector('[class^="gf-load-more-wrap-"]');

        var newNext = newWrap ? newWrap.getAttribute("data-next-url") : null;
        var newTotal = newWrap ? newWrap.getAttribute("data-total") : null;

        if (newTotal) {
          var parsedTotal = parseInt(newTotal, 10);
          if (Number.isFinite(parsedTotal) && parsedTotal > 0) {
            total = parsedTotal;
          }
        }

        setNextUrl(newNext);

        var viewed = setStatus();

        // If no more pages or we’ve reached total,
        // remove ONLY the button and keep the status text
        if (!getNextUrl() || viewed >= total) {
          btn.remove();
        } else {
          btn.disabled = false;
          btn.classList.remove("loading");
          btn.removeAttribute("aria-busy");
        }
      })
      .catch(function (error) {
        console.error("GF Load More error:", error);
        btn.disabled = false;
        btn.classList.remove("loading");
        btn.removeAttribute("aria-busy");
      })
      .finally(function () {
        btn.dataset.loading = "false";
      });
  });
})();
